<template>
  <div class="mx-2">
    <icon-view
      class="mr-2 mt-1 rounded-circle icon-view-color-text"
      icon="fas fa-file-search pl-1"
      icon-background="white"
      icon-color="#ff7058"
      icon-size="16px"
      title="Cambiar Estatus"
    />
    <div class="mt-3 mx-3">
      <validation-observer
        ref="requestProcedureStatusFormRef"
        tag="form"
        novalidate
      >
        <validation-provider v-slot="{ errors }" rules="required">
          <CustomDropDown
            v-model="model.status"
            :options="status"
            :clearable="false"
            label="Estatus:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
          />
        </validation-provider>
        <div class="mt-2 d-flex flex-column flex-lg-row justify-content-lg-end">
          <action-button
            id="btnCancel"
            text="Cancelar"
            variant="outline-danger"
            i="fas fa-times-circle"
            class="w-auto w-lg-0"
            @click="onCancelHandler"
          />
          <div class="my-1 mx-1 my-lg-0 mx-lg-2" />
          <action-button
            id="btnSave"
            text="Guardar"
            variant="success"
            i="fas fa-save"
            class="w-auto w-lg-0"
            @click="onSaveHandler"
          />
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
//libs
import IconView from "icon-view";
import CustomDropDown from "custom-drop-down";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";

//mixins
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

//services
import referralStudentService from "@/services/pc/referral-student";

//constants
import { publicPortalRequestTypes } from "@/utils/constants/student/publicPortalRequestTypes.js";

export default {
  name: "RequestProcedureChangeStatus",
  mixins: [alertMixin],
  components: {
    IconView,
    CustomDropDown,
    CustomTextArea,
    ActionButton
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    statusId: {
      type: Number,
      required: true
    },
    requestTypeId: {
      type: Number,
      required: true
    },
    studentSieId: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    model: {
      status: null
    },
    status: []
  }),
  computed: {
    isOnLineRegistration() {
      return this.requestTypeId === publicPortalRequestTypes.OnlineRegistration;
    }
  },
  async mounted() {
    await this.getStatus();
  },
  methods: {
    onCancelHandler() {
      this.$emit("cancel");
    },
    async getStatus() {
      await referralStudentService
        .getStatus(this.statusId, this.requestTypeId)
        .then(result => {
          this.status = result.data;
        })
        .catch(error => {
          this.ShowToast("Error", error.response.data.message, "error");
        });
    },
    async onSaveHandler() {
      const isValid = await this.$refs.requestProcedureStatusFormRef.validate();

      if (!isValid) {
        this.ShowToast("Error", "Informacion incompleta.", "error");
        return;
      }

      var payload = {
        id: this.id,
        statusId: this.model.status.id,
        typeId: this.requestTypeId,
        studentSieId: this.studentSieId
      };

      await referralStudentService
        .changeStatus(payload)
        .then(() => {
          this.ShowToast(
            "Confirmación",
            "La información ha sido guardada exitosamente.",
            "success"
          );

          this.$emit("saved");
        })
        .catch(error => {
          this.ShowToast("Error", error.response.data.message, "error");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.textarea__extended ::v-deep {
  .position-relative {
    i {
      display: none;
    }
  }
}
</style>
